const EMPTY_EXHIBITION_RESULTS = {
  aggregations: {},
  hits: [],
  pageCount: 1,
  currentPage: 1,
  resultCount: 0,
};

export const buildExhibitionSearchURL = (endpoint, data, displayLanguage) => {
  const queryParams = new URLSearchParams();
  const pageLimit = data?.limit || 9;
  const from = ((data?.page || 1) - 1) * pageLimit;

  queryParams.append('size', pageLimit);
  queryParams.append('from', from);

  if (data?.term) {
    queryParams.append('q', data.term);
  }

  const appendFacet = (key, values) => {
    if (!values) return;

    const normalizedValues = Array.isArray(values) ? values : [values];

    normalizedValues
      .filter(Boolean)
      .forEach(value => queryParams.append(key, value));
  };

  appendFacet('status', data?.filters?.status);
  appendFacet('location', data?.filters?.location);

  if (displayLanguage && displayLanguage !== 'en') {
    queryParams.append('l', displayLanguage);
  }

  return `${endpoint}?${queryParams.toString()}`;
};

export const normalizeExhibitionResponse = (payload) => {
  const pagination = payload?.pagination || {};
  const rawAggregations = payload?.aggregations || {};

  const normalizeAggregationList = (aggregation) => {
    const source = Array.isArray(aggregation)
      ? aggregation
      : (Array.isArray(aggregation?.buckets) ? aggregation.buckets : []);

    return source
      .map(item => ({
        key: item?.key || item?.value || item?.location_name || item?.field_location_name || '',
        count: item?.count ?? item?.doc_count ?? 0,
      }))
      .filter(item => Boolean(item.key));
  };

  const normalizeHit = (hit) => {
    const locationName = hit?.location_name || hit?.field_location_name || null;

    return {
      ...hit,
      location_name: locationName,
      field_location_name: hit?.field_location_name || locationName,
    };
  };

  return {
    aggregations: {
      location: normalizeAggregationList(rawAggregations.location || rawAggregations.location_name),
    },
    hits: (payload?.results || []).map(normalizeHit),
    resultCount: pagination.total || 0,
    pageCount: pagination.totalPages || 1,
    currentPage: pagination.currentPage || 1,
  };
};

export const fetchExhibitionResults = async (endpoint, data, displayLanguage) => {
  try {
    const url = buildExhibitionSearchURL(endpoint, data, displayLanguage);
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Exhibition search failed with status ${response.status}`);
    }

    const payload = await response.json();
    return normalizeExhibitionResponse(payload);
  } catch (err) {
    console.log(err.message);
    return EMPTY_EXHIBITION_RESULTS;
  }
};

export const emptyExhibitionResults = EMPTY_EXHIBITION_RESULTS;